import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
// import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
// import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faMediumM } from '@fortawesome/free-brands-svg-icons';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/TheCleverIdiott',
    label: 'Github',
    icon: faGithub,
  },
  // {
  //   link: 'https://www.instagram.com/ughhritra',
  //   label: 'Instagram',
  //   icon: faInstagram,
  // },
  {
    link: 'https://www.linkedin.com/in/aritraghosh1905/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://the-clever-idiot.medium.com/',
    label: 'Medium',
    icon: faMediumM,
  },
  {
    link: 'https://twitter.com/ughhritra',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'mailto:hello@aritra-ghosh.co',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
